import { render, staticRenderFns } from "./FormPRCT.vue?vue&type=template&id=12f3f4ae&scoped=true"
import script from "./FormPRCT.vue?vue&type=script&lang=js"
export * from "./FormPRCT.vue?vue&type=script&lang=js"
import style0 from "./FormPRCT.vue?vue&type=style&index=0&id=12f3f4ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3f4ae",
  null
  
)

export default component.exports